import ApiResponseBase from '../../../../Base/Domain/ApiResponseBase';

/**
  * @implements a refresh response model
  *
  */
class RefreshResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.AccessToken = params.accessToken || null;
    this.RefreshToken = params.refreshToken || null;

  }

}

export default RefreshResponseModel;